<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre9 sgc-14 sgc-51 sigil_not_in_toc">Contents</h1>
<p class="calibre1 dot1000"></p>
<p class="sgc-82"><a href="#/Text/ListofIllustrations">LIST OF ILLUSTRATIONS</a></p>
<p class="sgc-81"><a href="#/Text/ListofMaps">LIST OF MAPS</a></p>
<p class="sgc-81"><a href="#/Text/Foreword">FOREWORD</a></p>
<p class="sgc-81"><a href="#/Text/Preface">PREFACE</a></p>
<p class="sgc-81"><a href="#/Text/Introduction">INTRODUCTION TO AMERICAN MILITARY ORGANIZATION</a></p>
<p class="sgc-81"><a href="#/Text/Part01">Part I. THE BEGINNINGS: 1918–38</a></p>
<p class="sgc-19 indent2"><a href="#/Text/Chapter01"><span class="flt13">1.</span> Join the Tank Corps!</a></p>
<p class="sgc-19 indent2"><a href="#/Text/Chapter02"><span class="flt13">2.</span> Into the Breach: The Hindenburg Line Attack</a></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter03" title="Link target outside of Sample"><span class="flt13">3.</span> Lean Times: The Inter-War Years</span></p>
<p class="sgc-81"><span href="#/Text/Part02" title="Link target outside of Sample">Part II. WAR CLOUDS: 1939–41</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter04" title="Link target outside of Sample"><span class="flt13">4.</span> The Rebirth of American Armor</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter05" title="Link target outside of Sample"><span class="flt13">5.</span> Patton’s Blitzkrieg: The Tennessee Maneuvers</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter06" title="Link target outside of Sample"><span class="flt13">6.</span> Swamps and Snakes: The Louisiana Maneuvers</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter07" title="Link target outside of Sample"><span class="flt13">7.</span> Dress Rehearsal: The Carolina Maneuvers</span></p>
<p class="sgc-81"><span href="#/Text/Part03" title="Link target outside of Sample">Part III. THE MEDITERRANEAN THEATER: 1942–43</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter08" title="Link target outside of Sample"><span class="flt13">8.</span> Tanks at Sea: The Final Preparations: 1942</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter09" title="Link target outside of Sample"><span class="flt13">9.</span> Operation Torch: The Invasion of North Africa</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter10" title="Link target outside of Sample"><span class="flt12">10.</span> Operation Husky: Sicily</span></p>
<p class="sgc-81"><span href="#/Text/Part04" title="Link target outside of Sample">Part IV. OMAHA BEACH TO BERLIN: 1944–45</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter11" title="Link target outside of Sample"><span class="flt12">11.</span> Close Combat in the Hedgerows: Normandy</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter12" title="Link target outside of Sample"><span class="flt12">12.</span> Breakout and Pursuit: August 1944</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter13" title="Link target outside of Sample"><span class="flt12">13.</span> The Siege of Aachen</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter14" title="Link target outside of Sample"><span class="flt12">14.</span> Collapsing the Bulge: The Ardennes</span></p>
<p class="sgc-19 indent2"><span href="#/Text/Chapter15" title="Link target outside of Sample"><span class="flt12">15.</span> The Race for Berlin</span></p>
<p class="calibre7"><span href="#/Text/Epilogue" title="Link target outside of Sample">EPILOGUE</span></p>
<p class="calibre7"><span href="#/Text/Notes" title="Link target outside of Sample">NOTES</span></p>
<p class="calibre7"><span href="#/Text/Bibliography" title="Link target outside of Sample">BIBLIOGRAPHY</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?0f564dec